import React, { Component } from 'react'

// ui
import Modal from '../../../components/feedback/modal'
import Button from '../../../components/uielements/button'

import { Form, Input, Switch, Select, Upload } from 'antd'
import { FaCheck, FaTimes, FaPlus, FaSave } from 'react-icons/fa'
import { Spin } from 'antd'

// api
import { checkUsername } from '../../../services/apis/UserAPIServices'

// redux
import { connect } from 'react-redux'
import userActions from '../../../redux/user/actions'

// const 
import ListUserRolesType from '../../../constants/UserRoleConst'

const { Option } = Select

function getBase64(img, callback) {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
}

class UserInfoForm extends Component {
    state = {
        confirmDirty: false,
        loading: false,
        imageUrl: null,
    }

    handleConfirmBlur = e => {
        const { value } = e.target
        this.setState({ confirmDirty: this.state.confirmDirty || !!value })
    }

    // update new props
    componentWillReceiveProps(nextProps) {
        if (nextProps.user != this.props.user) {
            const { form, user } = nextProps
            //console.log('User info : ', user)
            form.setFieldsValue({ display_name: user.display_name })
            form.setFieldsValue({ user_name: user.user_name })
            //form.setFieldsValue({ organ_id: user.organ_id })
            //form.setFieldsValue({ tier_id: user.tier_id })
            form.setFieldsValue({ status: user.status === 1 })
            this.setState({ imageUrl: user.avatar })
        }
    }

    componentDidMount() {
        const { form, user } = this.props
        //console.log('User info : ', user)
        form.setFieldsValue({ display_name: user.display_name })
        form.setFieldsValue({ user_name: user.user_name })
       // form.setFieldsValue({ organ_id: user.organ_id })
        //form.setFieldsValue({ tier_id: user.tier_id })
        form.setFieldsValue({ status: user.status === 1 })
        this.setState({ imageUrl: user.avatar })
    }

    _handleOK = () => {
        this.props.dismiss()
    }

    _handleCancel = () => {
        this.props.dismiss()
    }

    render() {

        const { getFieldDecorator } = this.props.form
        const { user, organizations, currentOrganization } = this.props
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        }
        const { imageUrl } = this.state

        const uploadButton = (
            <div>
                {this.state.loading ? <Spin /> : <FaPlus />}
                <div className="ant-upload-text" style={{ fontSize: 13 }}>
                    Upload avatar
                </div>
            </div>
        )
        const default_avatar = require('../../../resource/image/defaultUser.png')

        return (
            <Form {...formItemLayout} onSubmit={this.onSubmit}>
                <Form.Item
                    label={null}
                    extra={null}
                    style={{ marginLeft: '40%' }}
                >
                    {getFieldDecorator('upload', {})(
                        <Upload
                            disabled
                            name="avatar"
                            //showUploadList={false}
                            listType="picture-card"
                            className="avatar-uploader"
                            style={{ backgroundColor: 'white' }}
                        >
                            <img
                                    src={imageUrl === '' ? default_avatar : imageUrl}
                                    alt="avatar"
                                    style={{ width: '100%' }}
                                />
                        </Upload>
                    )}
                </Form.Item>
                <Form.Item  label="Đơn vị" >
                    {getFieldDecorator('organi', {
                        initialValue: currentOrganization ? currentOrganization.name : ''
                    })(
                        <Input
                            readOnly
                            />
                    )}
                </Form.Item>
                <Form.Item label="Tên hiển thị" >
                    {getFieldDecorator('display_name', {
                        
                    })(
                        <Input
                            readOnly
                        />
                    )}
                </Form.Item>
                <Form.Item label="Tên đăng nhập" >
                    {getFieldDecorator('user_name', {
                    })(
                        <Input
                        readOnly
                        />
                    )}
                </Form.Item>
                <Form.Item  label=" Loại Người Dùng ">
                    {getFieldDecorator('tier_id', {
                        initialValue: ListUserRolesType.find(item => item.type===user.tier_id).name ? ListUserRolesType.find(item => item.type===user.tier_id).name : '' 
                    })(
                        <Input
                            readOnly
                        />
                    )}
                </Form.Item>
            </Form>
        )
    }
}

const mapStateToProps = state => {
    return {
        visible: state.user.modalShowCurrentUserInfoState,
        user: state.user.currentUser,
        organizations: state.organization.organizations,
        currentOrganization: state.organization.currentOrganization,
    }
}

const mapDispatchUserToProps = dispatch => {
    return {
        dismiss: () => {
            dispatch(userActions.action.dismissModalCurrentUserInfo())
        },
    }
}

const WrappedRegistrationForm = Form.create({ name: 'userinform' })(UserInfoForm)

const UserForm = connect(
    mapStateToProps,
    mapDispatchUserToProps
)(WrappedRegistrationForm)



class ModalUserInfo extends Component {
    _handleOK = () => {
        this.props.dismiss()
    }

    _handleCancel = () => {
        this.props.dismiss()
    }

    render() {
        const { visible } = this.props

        return (
            <Modal
                visible={visible}
                title="Thông tin người dùng "
                onOk={() => this._handleOK()}
                onCancel={() => this._handleCancel()}
                centered
                footer={null}
            >
                <UserForm />
            </Modal>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dismiss: () => {
            dispatch(userActions.action.dismissModalCurrentUserInfo())
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ModalUserInfo)
